<template>
  <div class="theme--light.application">
    <account reference="modal1" v-if="getLastSignupStep === 1" title="New Account" button="Next" :show="getLastSignupStep === 1" @submit="saveAccount"/>
    <payment reference="modal2" v-if="getLastSignupStep === 2" title="Payment Method" button="Next" :show="getLastSignupStep === 2" @submit="savePayment"/>
    <thanks reference="modal3" v-if="getLastSignupStep === 3" title="Done" button="Login" :show="getLastSignupStep === 3" @submit="goToLogin"/>
    <spinner v-if="loading" :fullScreen="true"/>
    <notifications group="error" position="bottom right" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import SIGNUP_USER from '@/graphql/SignupUser.gql';
// import CREATE_CAMPAIGN from '@/graphql/CreateCampaign.gql';
import NEW_CARD from '@/graphql/Billing/NewCard.gql';
import apiCall from '@/helpers/stepperApiCall';
import Spinner from '@/components/Spinner';
import LeadQuestion from '@/components/LeadQuestion';
import Account from './Account';
import Payment from './Payment';
import Thanks from './Thanks';
import Congratulations from './Congratulations';

export default {
  components: {
    Account,
    Payment,
    Thanks,
    LeadQuestion,
    Spinner,
    Congratulations,
  },
  computed: {
    ...mapGetters(['getLastSignupStep', 'getLandingUrl', 'getNewCampaignId']),
  },
  data() {
    return {
      loading: false,
      context: (this.$route.query.context) ? atob(this.$route.query.context) : '',
      companyId: null,
      email: null,
      gclid: null,
      affid: null,
    };
  },
  created() {
    this.checkAuth();
    this.checkCurrentStep();
  },
  mounted() {
    if (localStorage.getItem('affid')) {
      this.affid = localStorage.getItem('affid');
    } else {
      this.affid = this.$route.query.affid;
      if (this.affid) {
        localStorage.setItem('affid', this.affid);
      }
    }
  },
  methods: {
    ...mapActions([
      'login',
      'checkCurrentStep',
      'submitStep',
      'saveNewCampaignId',
      'saveLandingUrl',
      'checkAuth',
      'trackEvent',
      'trackAffilate',
      'trackPaymentInfo'
    ]),
    // eslint-disable-next-line
    saveAccount: apiCall(async function(input) {
      const result = await this.$apollo.mutate({
        mutation: SIGNUP_USER,
        variables: { input: {
            ...input,
            affiliateId: this.affid
          } },
      });

      const signupByUser = result.data.signupByUser;

      this.companyId = signupByUser.user.companyId;
      this.email = input.email;

      this.login(signupByUser);
      this.submitStep(this.getLastSignupStep);
      this.sendGtagEvent('Account Created', `${input.companyName} | ${input.userName} <${input.email}>`);
      this.trackEvent({name: "Signup"});
      // if (this.affid) {
      //   this.trackAffilate({affiliateId: this.affid});
      // }
    }),
    // eslint-disable-next-line
    savePayment: apiCall(async function(input) {
      await this.$apollo.mutate({
        mutation: NEW_CARD,
        variables: {
          id: this.companyId,
          input: {
            token: input.token.id,
            customerEmail: this.email,
            holderEmail: this.email,
            cardholder: input.name,
          },
        },
      });

      this.submitStep(this.getLastSignupStep);
      this.sendGtagEvent('Payment Added', this.companyId);
    }),
    // eslint-disable-next-line
    // saveCampaign: apiCall(async function(input) {
    //   const result = await this.$apollo.mutate({
    //     mutation: CREATE_CAMPAIGN,
    //     variables: { input },
    //   });
    //   this.saveNewCampaignId(result.data.createCampaign.campaignId);
    //   this.saveLandingUrl(
    //     `${process.env.PAGES_URI}/${result.data.createCampaign.landingName}`
    //   );
    //   this.sendGtagEvent('Campaign Created', input.campaignName);
    //   this.trackEvent({
    //     name: "Campaign Created",
    //     options: {
    //       "campaignName": input.campaignName,
    //     }
    //   });
    //   this.submitStep(this.getLastSignupStep);
    // }),
    // nextStep(input) {
    //   const step = this.getLastSignupStep;
    //   this.submitStep(step);
    // },
    goToLogin() {
      this.$router.push({ name: 'Login' })
    },
    // goToNextStep() {
    //   this.$refs[this.getLastSignupStep].submit();
    // },
    sendGtagEvent(action, label) {
      if (window.gtag) {
        window.gtag('event', action, {
          'event_category': 'NextLead_Portal_Signup',
          'event_label': label
        });
      }
    },
  },
};
</script>
<style scoped>
.logo {
  max-height: 45px;
}
hr {
  margin-top: 0;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Signup/Signup.vue